import moment from "moment";
import { Cell } from "react-table";
import { ProviderModel } from "src/api/provider/provider-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import { PagePath } from "src/pages/product/details";
import { companyRegistrationHypen, ViewYmdFormat } from "src/utils";

const ProviderColumns = [
  {
    Header: "정산정보 ID",
    accessor: "providerId",
    width: 120,
    Cell: ({ row, value }: Cell<ProviderModel>) => {
      const detailPath = `${PagePath.provider.detail.replace(":id", String(row.original.providerId))}`;

      return (
        <DetailLink to={detailPath} className="text-underline">
          {value}
        </DetailLink>
      );
    },
  },
  {
    Header: "정산처 유형",
    accessor: "supplyType",
    width: 140,
    Cell: ({ value }: Cell<ProviderModel>) => {
      return <div className="w-100 text-center">{value === "RENTAL" ? "프로바이더" : "관리처"}</div>;
    },
  },
  {
    Header: "정산처(법인명/상호)",
    accessor: "providerName",
    width: 240,
    Cell: ({ value }: Cell<ProviderModel>) => {
      return <BaseTooltip className="w-100 text-left" contents={value || "-"} />;
    },
  },
  {
    Header: "사업자 등록번호",
    accessor: "businessRegistrationNumber",
    width: 160,
    Cell: ({ value }: Cell<ProviderModel>) => {
      return companyRegistrationHypen(value);
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "modifiedDate",
    width: 160,
    Cell: ({ value }: Cell<ProviderModel>) => {
      return <div className="w-100 text-center">{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</div>;
    },
  },
];

export default ProviderColumns;
